/**
 * WordPress Dependencies
 */

import { InspectorControls } from "@wordpress/block-editor";
/**
 * Custom Imports
 */
import { PlayButton, VideoLightboxControls } from "./components";

function Inspector(props) {
	const { attributes } = props;

	return (
		<InspectorControls>
			<VideoLightboxControls {...props} />
			{attributes.ghubVideoLightbox && <PlayButton {...props} />}
		</InspectorControls>
	);
}

export default Inspector;
